import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-dialog-header",
  templateUrl: "./dialog-header.component.html",
  styleUrls: ["./dialog-header.component.scss"]
})
export class DialogHeaderComponent implements OnInit
{

  @Input() title: string;
  @Input() icon: string = ""; // icon element only shows if icon !== ""
  @Input() showXButton: boolean = true;

  constructor() { }

  ngOnInit(): void
  {

  }

}
